<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <form class="col-lg-6 col-md-6 col-sm-4" >
                    <div class="input-group mb-4 mt-4 ">
                        <label class="input-group">
                            <h3>
                                {{ $t('marketing.marketing_tools.register_link') }}
                            </h3>
                        </label>
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa fa-copy"  style="font-size:24px; cursor:pointer" title="copy" @click="copy"></i>
                            </span>
                        </div>
                        <input class="form-control" type="text"  name="register_link" id="register_link" disabled>
                    </div>
                </form>
                <div class="line-divider mt-3 mb-1"></div>
                <form class="mt-lg-3">
                    <div class="input-group mb-4">
                        <label class="input-group">
                            <h3>
                                {{ $t('marketing.marketing_tools.banner') }}
                            </h3>
                        </label>
                        <div class="col-lg-6 col-md-6 col-sm-4 border-right">
                            <kt-form-group class="mt-lg-4 mt-md-4 mt-sm-3">
                                <kt-form-label>
                                    <h4>
                                        {{ $t('marketing.marketing_tools.horizental_banner') }}
                                    </h4>
                                </kt-form-label>
                                <div>
                                    <img :src="marketing_tools.hor_banner" alt="register-link" class="hor_banner">
                                </div>
                            </kt-form-group>
                            <kt-form-group>
                                <kt-form-label class="form-group">
                                    {{ $t('marketing.marketing_tools.using_banner') }}
                                </kt-form-label>
                                <div>
                                    <textarea
                                            id="html_750"
                                            class="col-lg-12 col-md-12 col-sm-6 banner_text_area"
                                            disabled dir="ltr">
                                    </textarea>
                                </div>
                            </kt-form-group>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-4">
                            <kt-form-group class="mt-lg-4 mt-md-4 mt-sm-3">
                                <kt-form-label>
                                    <h4>
                                        {{ $t('marketing.marketing_tools.vertical') }}
                                    </h4>
                                </kt-form-label>
                                <div>
                                    <img :src="marketing_tools.ver_banner" alt="register-link" class="ver_banner">
                                </div>
                            </kt-form-group>
                            <kt-form-group>
                                <kt-form-label class="form-group">
                                    {{ $t('marketing.marketing_tools.using_banner') }}
                                </kt-form-label>
                                <div>
                                    <textarea
                                            id="html_440"
                                            class="col-lg-12 col-md-12 col-sm-6 banner_text_area"
                                            disabled dir="ltr"></textarea>
                                </div>
                            </kt-form-group>
                        </div>
                    </div>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import $ from 'jquery'
    import { mapGetters } from "vuex";

    export default {
        name: 'MarketingDashboard',
        components: {
            'main-content': mainContent,
        },
        computed: {
            ...mapGetters('marketing', [
                'marketing_tools'
            ])
        },
        mounted() {
            this.$store.dispatch('marketing/fetchMarketingTools').finally(() => {
                this.afterDispatch()
            })
        },
        methods: {
            afterDispatch() {
                this.loadHtml()
                this.getLink()
            },
            copy() {
                let copiedLink = $('#register_link')
                copiedLink.removeAttr('disabled');
                copiedLink.select()
                document.execCommand("copy")
                copiedLink.attr('disabled','disabled');
            },
            loadHtml() {
                $('#html_750').val('<div>' +
                    '<a href=\''+ window.location.origin +'/register/' + this.marketing_tools.referer_id + '\'>' +
                    '<img src=\''+this.marketing_tools.hor_banner+'\' alt=\'register-link\'>' +
                    '</a>' +
                    '</div>')
                $('#html_440').val('<div>' +
                    '<a href=\''+ window.location.origin +'/register/' +  this.marketing_tools.referer_id + '\'>' +
                    '<img src=\''+this.marketing_tools.ver_banner+'\' alt=\'register-link\' >' +
                    '</a>' +
                    '</div>')
            },
            getLink() {
                $('#register_link').val(window.location.origin + '/register/' + this.marketing_tools.referer_id)
            }
        }

    }
</script>

<style>
    @media screen and (max-width: 1024px){
        .hor_banner {
            width:200px;
            height:60px
        }
        .ver_banner {
            width:70px;
            height:90px
        }
    }
    @media screen and (min-width: 1024px) {
        .hor_banner {
            width:200px;
            height:60px
        }
        .ver_banner {
            width:70px;
            height:90px
        }
    }
    .banner_text_area {
        min-height: 110px
    }
    .line-divider {
        height:1px;
        background-color: #dee2e6
    }
</style>